module.exports = __webpack_public_path__ + "static/media/13. Fusión, Óleo y resina en lino, 90 x 140 cm, 2015 copy.2c61abe6.png";